import type { ApiClient } from './api-client';

/**
 * Downloads a CSV the API serves (same-origin session; a refusal arrives as an ApiProblem, never as a broken file).
 * The file is built in memory and handed to the browser: nothing is stored by the application.
 */
export async function downloadCsv(api: ApiClient, path: string, fileName: string): Promise<void> {
  const { data } = await api.get<string>(path);
  const blob = new Blob([utf16le(data)], { type: 'text/csv;charset=utf-16le' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * The text as UTF-16LE with its byte order mark: Excel opens such a tab-separated file one value per column whatever
 * the computer's list separator, with every accent (owner, 2026-10-07). Reading the response as text dropped the API's
 * own byte order mark, so it is written here.
 */
export function utf16le(text: string): Uint8Array<ArrayBuffer> {
  const bytes = new Uint8Array(2 + text.length * 2);
  const view = new DataView(bytes.buffer);
  view.setUint16(0, 0xfeff, true);
  for (let i = 0; i < text.length; i += 1) view.setUint16(2 + i * 2, text.charCodeAt(i), true);
  return bytes;
}
